module.exports = __webpack_public_path__ + "media/hd_bg.e1c4c217.mp4";